// material-ui
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormattedMessage } from "react-intl";
import React from "react";

// ==============================|| COMPONENTS - MODAL ACTION ||============================== //

interface Props {
    open: boolean;
    title: string;
    content: string;
    buttonContent: string;
    handleClose: () => void;
    handleAction?: () => void;
}

const ModalAction = ({ open, title, content, buttonContent, handleClose, handleAction }: Props) => {

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            keepMounted
            aria-labelledby="item-delete-title"
            aria-describedby="item-delete-description"
        >
            {open && (
                <>
                    <DialogTitle id="item-delete-title">{title}</DialogTitle>
                    <DialogContent>{content}</DialogContent>
                    <DialogActions sx={{ mr: 2 }}>
                        <Button onClick={handleClose} color="error">
                            <FormattedMessage id={'SYS00003'} />
                        </Button>
                        <Button variant="contained" size="small" onClick={handleAction} autoFocus>
                            {buttonContent}
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
};

export default ModalAction;